/* eslint-disable camelcase */
import { CbSubscription } from '@lmc/common/types'
import { groupBy } from 'lodash'


enum SUBSCRIPTIONS_STATUSES {
  ACTIVE = 'active',
  IN_TRIAL = 'in_trial',
  NON_RENEWING = 'non_renewing',
  OVERDUE = 'overdue',
  CANCELLED = 'cancelled',
}

export const filterDuplicateSubscriptions = (
  subscriptions: CbSubscription[]
) => {
  const subscriptionsWithIdentifier = subscriptions?.map((item) => {
    const plan_id = item.subscription_items?.[0]?.item_price_id || item?.plan_id
    let planIdentifier = plan_id.split('-')[0]
    // care-plans and pro have merged
    if (planIdentifier === 'care') planIdentifier = 'pro'
    return {
      ...item,
      planIdentifier,
    }
  })

  const tempArray: any[] = []

  Object.values(groupBy(subscriptionsWithIdentifier, 'planIdentifier')).forEach(
    (sub) =>
      sub.forEach((item) => {
        switch (item.status) {
          case SUBSCRIPTIONS_STATUSES.ACTIVE:
            if (
              !tempArray.some(
                (tempItem) => tempItem.planIdentifier === item.planIdentifier
              )
            ) {
              tempArray.push(item)
            }
            break
          case SUBSCRIPTIONS_STATUSES.IN_TRIAL:
            if (
              !tempArray.some(
                (tempItem) => tempItem.planIdentifier === item.planIdentifier
              )
            ) {
              tempArray.push(item)
            }
            break
          case SUBSCRIPTIONS_STATUSES.NON_RENEWING:
            if (
              !tempArray.some(
                (tempItem) => tempItem.planIdentifier === item.planIdentifier
              )
            ) {
              tempArray.push(item)
            }
            break
          case SUBSCRIPTIONS_STATUSES.OVERDUE:
            if (
              !tempArray.some(
                (tempItem) => tempItem.planIdentifier === item.planIdentifier
              )
            ) {
              tempArray.push(item)
            }
            break
          default:
            if (
              !tempArray.some(
                (tempItem) => tempItem.planIdentifier === item.planIdentifier
              )
            ) {
              tempArray.push(item)
            }
        }
      })
  )
  return tempArray
}
